// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.globalSearch_searchContainer__KgT\\+Y {
  position: relative;
  width: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/components/GlobalSearch/globalSearch.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd","sourcesContent":[".searchContainer {\n  position: relative;\n  width: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchContainer": `globalSearch_searchContainer__KgT+Y`
};
export default ___CSS_LOADER_EXPORT___;
